import * as T from "../Controls.style";
import { get } from "lodash";
import { Inputs } from "@/components/atoms/Inputs";
import { ChangeEvent } from "react";
import { Control, Controller } from "react-hook-form";

interface TelControlProps {
  max?: string;
  name: string;
  type?: string;
  label?: string;
  value?: string;
  control: Control<any>;
  tabIndex?: number;
  required?: boolean;
  disabled?: boolean;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  defaultValue?: string;
}

export const TelControl = ({
  max,
  name,
  label,
  value,
  control,
  required,
  tabIndex,
  onChange,
  placeholder,
  defaultValue,
  type = "text",
  disabled = false,
}: TelControlProps) => {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field, formState }) => (
        <T.Controls>
          <Inputs label={label} required={required ? required : false}>
            <input
              type={type}
              autoCapitalize="none"
              {...field}
              placeholder={placeholder}
              max={max}
              tabIndex={tabIndex}
              value={value}
              onChange={(e) => {
                field.onChange(e);
                if (onChange) onChange(e);
              }}
              maxLength={13}
              disabled={disabled}
            />
          </Inputs>
          {get(formState.errors, name)?.message && (
            <span>
              <>{get(formState.errors, name)?.message}</>
            </span>
          )}
        </T.Controls>
      )}
    />
  );
};
